import { ATTRIBUTE_TYPES } from '@yandex-int/k-common/constants';
import PropTypes from 'prop-types';

export const attributeFilterPropType = PropTypes.shape({
    description: PropTypes.string,
    isTechnical: PropTypes.bool,
    name: PropTypes.string,
    slug: PropTypes.string,
    typeSlug: PropTypes.oneOf(Object.values(ATTRIBUTE_TYPES)),
    variants: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            slug: PropTypes.string,
        })
    ),
});
